var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 3.99988C11.8749 3.8749 11.7053 3.80469 11.5285 3.80469C11.3518 3.80469 11.1822 3.8749 11.0572 3.99988L7.99988 7.05721L4.94255 3.99988C4.81753 3.8749 4.64799 3.80469 4.47121 3.80469C4.29444 3.80469 4.1249 3.8749 3.99988 3.99988C3.8749 4.1249 3.80469 4.29444 3.80469 4.47121C3.80469 4.64799 3.8749 4.81753 3.99988 4.94255L7.05721 7.99988L3.99988 11.0572C3.8749 11.1822 3.80469 11.3518 3.80469 11.5285C3.80469 11.7053 3.8749 11.8749 3.99988 11.9999C4.1249 12.1249 4.29444 12.1951 4.47121 12.1951C4.64799 12.1951 4.81753 12.1249 4.94255 11.9999L7.99988 8.94254L11.0572 11.9999C11.1822 12.1249 11.3518 12.1951 11.5285 12.1951C11.7053 12.1951 11.8749 12.1249 11.9999 11.9999C12.1249 11.8749 12.1951 11.7053 12.1951 11.5285C12.1951 11.3518 12.1249 11.1822 11.9999 11.0572L8.94254 7.99988L11.9999 4.94255C12.1249 4.81753 12.1951 4.64799 12.1951 4.47121C12.1951 4.29444 12.1249 4.1249 11.9999 3.99988Z",
    fill: "#0090D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFilter);
export default __webpack_public_path__ + "static/media/closeFilter.c37134872d4227e50cf6d9f5c28f2b21.svg";
export { ForwardRef as ReactComponent };